module.exports = __webpack_public_path__ + "static/media/ne.e56edd30.svg";